<template>
  <el-dialog title="紧急发布" center class="devOps-modelRunurgent" :visible.sync="dialogVisible" width="80%" top="10px"
             :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="主域名" prop="domain">
        <el-select style="width: 100%" @change="onChangeSelect('domain')"
                   :remote-method="remoteMethod.bind(this, 'domain')" v-model="form.domain" placeholder="请选择主域名">
          <el-option v-for="(item, index) in domains" :key="index" :label="item[0] + ' （' + item[1] + '）'"
                     :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块名" prop="module">
        <el-select style="width: 100%" filterable collapse-tags v-model="form.module" :placeholder="'请选择模块名'"
                   @change="onChangeSelect('module')" :remote-method="remoteMethod.bind(this, 'branch')">
          <el-option v-for="(item, index) in modules" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分支" prop="branch">
        <el-select style="width: 100%" v-model="form.branch" filterable remote reserve-keyword
                   @change="onChangeSelect('branch')" placeholder="请选择分支" :remote-method="remoteMethod.bind(this, 'branch')">
          <el-option v-for="item in branchOptions" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本" prop="commit">
        <el-select style="width: 100%" v-model="form.commit" filterable remote reserve-keyword placeholder="请选择版本"
                   @change="onChangeCommit">
          <el-option v-for="item in commitOptions" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="环境" prop="env">
        <el-select style="width: 100%" :disabled="true" v-model="form.env" placeholder="请选择环境" filterable>
          <el-option v-for="(item, index) in envs" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请人" prop="applicant">
        <el-select style="width: 100%" size="mini" autocomplete="off" v-model="form.applicant" collapse-tags filterable placeholder="请填写紧急发布申请人" :remote-method="remoteMethod.bind(this, 'applicant')" @focus="onFocusApplicant">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <!--      <el-form-item label="申请人" prop="applicant">
              <el-select style="width: 100%" v-model="form.applicant" filterable remote reserve-keyword
                placeholder="请填写紧急发布申请人" :remote-method="remoteMethod.bind(this, 'applicant')" @focus="onFocusApplicant">
                <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value" />
              </el-select>
            </el-form-item> -->
      <el-form-item label="描述" prop="describe">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 16 }" placeholder="请输入描述" v-model="form.describe">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="runLoading" type="warning" @click="onSubmit('runurgent')">开始发布</el-button>
        <el-button style="margin-top:5px;" type="warning" @click="onSubmit('log')">实时日志</el-button>
        <el-button type="warning" @click="handleClose">返 回</el-button>
      </el-form-item>
    </el-form>
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
               title="生产环境代码发布" v-if="releaseResultVisible" :visible.sync="releaseResultVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="75%" center
               title="生产环境实时日志" v-if="releaseResultLogVisible" :visible.sync="releaseResultLogVisible" append-to-body>
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  postDevopsSpaceStageActionApi,
  postODUDADcreateApi,
  getDevOpsSpaceStageSelectmapApi,
} from "@/server/tops/devOps";

import { Progress, WebSocket } from "@/components/index.js";
import { TableOne } from "../table/index";
import { filterSelectList, formatDate } from "../util";
import { mapState, mapMutations } from "vuex";
export default {
  components: { Progress, TableOne, WebSocket },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        domain: "ehsy.com",
        env: "production",
      },
      rules: {
        applicant: [
          { required: true, message: "请填写紧急发布申请人", trigger: "blur" },
        ],
        domain: [{ required: true, message: "请选择域名", trigger: "blur" }],
        module: [{ required: true, message: "请选择模块名", trigger: "blur" }],
        branch: [{ required: true, message: "请选择分支", trigger: "blur" }],
        commit: [{ required: true, message: "请选择版本", trigger: "blur" }],
        env: [{ required: true, message: "请选择环境", trigger: "blur" }],
        describe: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
      applicants: [],
      applicantOptions: [],
      branchs: [],
      branchOptions: [],
      envs: [],
      commits: [],
      commitOptions: [],
      modules: [],
      cacheModules: [],
      domains: [],
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
      releaseResultVisible: false,
      releaseResultLogVisible: false
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceStageSelectmapApi();
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      webSocket: (state) => state.devOps.WEBSOCKET,
      allUserList: (state) => state.devOps.ALLUSERLIST,
    }),
  },
  updated() {
    this.scrollToBottom({ bind: this, refName: 'webSocket' })
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      try {
        const ret = await postODUDADcreateApi({
          module_name: "BACKEND",
          domain:this.form.domain
        });
        this.branchs = this.branchOptions = ret.branchs.map((item) => {
          return { value: `${item}`, label: `${item}` };
        });

        this.commits = this.commitOptions = ret.commits.map((item) => {
          return { value: `${item.split(" ")[0]}`, label: `${item}` };
        });
        const res = await getDevOpsSpaceStageSelectmapApi();
        this.domains = res["operator_prodCodeDeploy-domain"];
        this.cacheModules = res["devops-tasklist-module"];
        this.modules = res["devops-tasklist-module"].filter(item => item[2] === this.form.domain);
        /*     this.applicants = this.applicantOptions = res[
               "devops-tasklist-users"
             ].map((item) => {
               return { value: `${item[1]}`, label: `${item[0]}（${item[1]}）` };
             });*/
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisibleRunurgent");
    },
    // 提交
    async onSubmit(action) {
      action === "runurgent" && (await this.queryActionRunSubmit(action));
      action === "log" && (await this.queryActionNowLogSubmit(action));
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            module = "",
            describe = "",
            applicant = "",
            branch = "",
            commit = "",
            env = "",
            domain = "",
          } = this.form;
          const param = {
            action,
            domain,
            module,
            describe,
            applicant,
            branch,
            commit,
            env,
            stage_name: "operator_prodCodeDeploy",
          };
          try {
            const cacheDate = new Date();
            this.runLoading = true;
            this.releaseResultVisible = true;
            this.tableData = []
            const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
            this.openWebSocket({
              url: '/ws/devops',
              params: { pid: 0, task_id: 0, stage_id: 0, username },
              title: '生产环境紧急发布'
            })
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret?.output || {};
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
            const isSuccess = typeof output === 'string' ? false : output?.deploy[0]?.code === 0;
            this.timeOutSetProgressBar(`发布${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
          } catch (error) {
            this.timeOutSetProgressBar('发布失败')
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 实时日志
    async queryActionNowLogSubmit() {
      const {
        stage_id = "0",
        task_id = "0",
        pid = '0'
      } = this.modelParam;
      this.tableData = [];
      this.releaseResultLogVisible = true;
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.openWebSocket({
        url: '/ws/devops',
        params: { pid, task_id, stage_id, username },
        title: '生产环境代码发布'
      })
    },
    remoteMethod(key = "", query = "") {
      this[key + "Options"] = filterSelectList(this[key + "s"], query);
    },
    // 版本change事件
    async onChangeSelect(type) {
      if (type === 'domain') {
        this.modules = this.cacheModules.filter(item => {
          return item[2] === this.form.domain
        });
        this.form.module = this.modules[0][1] || '';
      }
      if (type === "module" || type === 'domain') {
        this.form.branch = "";
        this.branchs = "";
        this.branchOptions = "";
      }
      this.form.commit = "";
      this.commits = [];
      this.commitOptions = [];
      try {
        const ret = await postODUDADcreateApi({
          module_name: this.form.module || "",
          branch: this.form.branch,
          domain: this.form.domain,
        });
        this.branchs = this.branchOptions = ret.branchs.map((item) => {
          return { value: `${item}`, label: `${item}` };
        });
        if (type === "module" || type === 'domain') {
          this.form.branch = ret?.branchs ? ret.branchs[0] : "";
          this.onChangeSelect("branch");
        }
        if (type === "branch" || type === 'domain') {
          this.commits = this.commitOptions =
              ret?.commits?.map((item) => {
                return { value: `${item.split(" ")[0]}`, label: `${item}` };
              }) || [];
          this.form.commit = ret?.commits ? ret.commits[0].split(' ')[0] : "";
        }
      } catch (error) { }
    },
    onChangeCommit() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 申请人重置select
    onFocusApplicant(val) {
      this.applicantOptions = this.applicants;
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 480px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}
</style>
<style lang="scss">
.devOps-modelRunurgent {

  .el-input__inner,
  .el-textarea__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }

  .el-form-item {
    margin-bottom: 12px;
    margin-bottom: 15px;
  }
}
</style>
